// Client for the /advertise funnel endpoints.
// Mock fallbacks are DEV/TEST only — production builds always surface real errors.
const BASE = '/api/public/v1/advertise';
const ALLOW_MOCK = process.env.NODE_ENV !== 'production';

const uid = () => (typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `id-${Date.now()}-${Math.random().toString(16).slice(2)}`);

async function postJson(path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = new Error(`Request failed: ${res.status}`);
    err.status = res.status;
    try { err.detail = (await res.json())?.detail; } catch (_) {}
    throw err;
  }
  return res.json();
}

export function computeQuoteAmount(listPrice) {
  const price = Number(listPrice) || 0;
  if (!price || price < 700000) return 260;
  if (price < 1000000) return 399;
  return 499;
}

function mockDemoSlots() {
  const slots = [];
  let day = new Date();
  day.setDate(day.getDate() + 1);
  let businessDaysAdded = 0;
  while (businessDaysAdded < 5) {
    if (day.getDay() !== 0 && day.getDay() !== 6) {
      for (const hour of [10, 13, 15]) {
        const dt = new Date(day);
        dt.setHours(hour, 0, 0, 0);
        slots.push({
          iso: dt.toISOString(),
          label: dt.toLocaleString('en-US', { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }),
        });
      }
      businessDaysAdded += 1;
    }
    day = new Date(day.getTime() + 24 * 60 * 60 * 1000);
  }
  return slots;
}

export async function submitLead(track, payload) {
  try {
    return await postJson('/leads', { track, payload, website: '' });
  } catch (e) {
    if (!ALLOW_MOCK) throw e;
    return { id: uid(), status: 'received' };
  }
}

export async function getBoostQuote({ address, listPrice }) {
  try {
    return await postJson('/boost/quote', { address, list_price: listPrice ? Number(listPrice) : null });
  } catch (e) {
    if (!ALLOW_MOCK) throw e;
    const amount = computeQuoteAmount(listPrice);
    return { quote_id: uid(), amount, currency: 'usd', breakdown: 'Single Listing Boost — active until your home is sold' };
  }
}

export async function createBoostCheckout({ quoteId, sellers }) {
  try {
    return await postJson('/boost/checkout', { quote_id: quoteId, sellers });
  } catch (e) {
    if (!ALLOW_MOCK) throw e;
    const session_id = uid();
    return { checkout_url: `/advertise/sellers/thank-you?session_id=${session_id}`, session_id };
  }
}

export async function getBoostOrder(sessionId) {
  try {
    const res = await fetch(`${BASE}/boost/order/${sessionId}`);
    if (!res.ok) throw new Error(res.status);
    return await res.json();
  } catch (e) {
    if (!ALLOW_MOCK) throw e;
    return { session_id: sessionId, status: 'paid', amount: null, currency: 'usd' };
  }
}

export async function getDemoSlots(track = 'agents') {
  try {
    const res = await fetch(`${BASE}/demo/slots?track=${encodeURIComponent(track)}`);
    if (!res.ok) throw new Error(res.status);
    return await res.json();
  } catch (e) {
    if (!ALLOW_MOCK) throw e;
    return mockDemoSlots();
  }
}
